export default __webpack_public_path__ + "b9c62a4c689a3800334e9f6e96829385.svg";